<script>
  // https://blog.minhazav.dev/research/html5-qrcode
  export let loadImage;
</script>

<div>
  <button on:click={loadImage(1)}>Simulate pic 1</button>
  <p>Scan!</p>
</div>

<style>
  #container {
    margin: 0px auto;
    width: 500px;
    height: 375px;
    border: 10px #333 solid;
  }
  #videoElement {
    width: 500px;
    height: 375px;
    background-color: #666;
  }
</style>
